import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { StaticInfoMessage } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SelfInvoiceSection: React.FC = () => {
  const selfInvoiceEmailAddress = useSelector(
    (store: AppState) => store.auth.selectedCompany.loggedInUserSelfInvoiceEmail
  );

  return (
    <StaticInfoMessage>
      <Grid item container className={cssExports.whiteSpacePre}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SelfInvoiceCreateFromInfo, undefined, {
          email: selfInvoiceEmailAddress ?? "",
        })}
        <p>
          <span className={cssExports.boldContent}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ProTip).concat(": ")}
          </span>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SelfInvoiceCreateFromTip)}
        </p>
      </Grid>
    </StaticInfoMessage>
  );
};
export default SelfInvoiceSection;
